import React from 'react';

// Tree framing component - displays tree image on left and right sides
// Note: Waiting for "arbre" image to be provided
export const TreeFraming = () => {
  // Placeholder - will be updated when tree image is provided
  return null;
};

// Orange decorations removed as per design update
// Only Orange 3 is kept in the navigation menu
export const OrangeDecorations = () => {
  return null;
};
